import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
// tslint:disable:max-line-length
import React from 'react';
export var OperatorContains = function OperatorContains(props) {
  var _props$ariaLabel = props.ariaLabel,
      ariaLabel = _props$ariaLabel === void 0 ? 'Contains' : _props$ariaLabel,
      remProps = _objectWithoutProperties(props, ["ariaLabel"]);

  return React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16",
    "aria-label": ariaLabel
  }, remProps), React.createElement("path", {
    d: "M5.37 14.58a1.88 1.88 0 0 1-2-2.07v-2c0-1.37-.5-1.68-1.55-1.68V7.2c1.05 0 1.55-.31 1.55-1.68v-2a1.88 1.88 0 0 1 2-2.07h2V3h-.63a1 1 0 0 0-1.09 1.09v1.74c0 1.37-.43 1.9-1.19 2.16V8c.76.25 1.19.78 1.19 2.16v1.74A1 1 0 0 0 6.74 13h.62v1.57zM8.64 14.58V13h.62a1 1 0 0 0 1.09-1.11V10c0-1.37.43-1.7 1.19-1.95V8c-.76-.25-1.19-.57-1.19-1.95V4.09C10.35 3.38 10 3 9.27 3h-.61V1.42h2.2c1.29 0 1.78.64 1.78 1.86v2.24c0 1.37.5 1.68 1.55 1.68v1.6c-1.05 0-1.55.31-1.55 1.68v2.24c0 1.22-.49 1.86-1.78 1.86z"
  }));
};